/* eslint-disable */
let tmpLocalStorage = {};
let tmlSessionStorage = {};
try {
    tmpLocalStorage = window.localStorage;
} catch (e) {}
try {
    tmlSessionStorage = window.localStorage;
} catch (e) {}

export const storages = {
    local: tmpLocalStorage,
    session: tmlSessionStorage,
};

export class Storage {
    storage = undefined;

    constructor(scopeName, type = 'local') {
        this.scopeName = scopeName;

        if ({}.hasOwnProperty.call(storages, type)) {
            this.storage = storages[type];
        } else {
            throw `Could not find storage with type '${type}'`;
        }

        try {
            this.data = JSON.parse(this.storage.getItem(scopeName)) || {};
        } catch (e) {
            this.data = {};
        }
    }

    /**
     * Get items keys without start at _ (underscore) char
     *
     * @returns {Array.<string>} list of storage items keys
     */
    index() {
        return Object.keys(this.data).filter(key => key.charAt(0) !== '_');
    }

    /**
     * Get item from storage
     *
     * @param {string} key  key of item
     * @returns {*} value of storage item
     */
    get(key) {
        if (!{}.hasOwnProperty.call(this.data, key) || typeof this.data[key] === 'undefined')
            return null;
        return this.data[key];
    }

    /**
     * Set value to item by key
     *
     * @param {string} key  value key
     * @param {*} value  item value
     */
    set(key, value) {
        this.data[key] = value;
        this.save();
    }

    /**
     * Remove item from storage
     *
     * @param key  value key
     */
    unset(key) {
        this.data[key] = undefined;
        this.save();
    }

    /**
     * Remove all items from storage
     */
    clear() {
        this.data = {};
        this.save();
    }

    /**
     * Save storage items to browser storage.
     */
    save() {
        try {
            this.storage.setItem(this.scopeName, JSON.stringify(this.data));
        } catch (e) {
            console.error(e);
        }
    }
}
